import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Detail } from '../models/details';
import { ReceiptsService } from '../receipts.service';

@Component({
  selector: 'app-recharge-resume-final',
  templateUrl: './recharge-resume-final.component.html',
  styleUrls: ['./recharge-resume-final.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class RechargeResumeFinalComponent implements OnInit {

	receipt: Detail = new Detail();

	constructor(
		private router: Router,
		private receiptsService: ReceiptsService
	) {}

	ngOnInit(): void {
		this.receipt = this.receiptsService.getSelectedReceipt();
		this.invalidParams() ? this.goBack() : '';
	}

	invalidParams(): boolean {
		return this.receipt === undefined ||
			this.receipt.value === undefined
	}

	goBack = () => this.router.navigate(['comprovantes/']);
	emitNew = () => this.router.navigate(['comprovantes/']);
	emitPrint = () => window.print();
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/receipts/recharge-resume-final/recharge-resume-final.component.ts